import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f29b362")

_pushScopeId("data-v-1f29b362")
const _hoisted_1 = { class: "form-group squareInputContainer withLabel mt-3" }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_uose_writer = _resolveComponent("uose-writer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.titleKey && _ctx.titleText)
      ? (_openBlock(), _createBlock("label", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: _ctx.titleKey,
            text: _ctx.titleText,
            class: "fs_12 grey"
          }, null, 8, ["localizedKey", "text"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_uose_writer, {
      class: "genericInput squareInput ptInput uoseWriter",
      modelValue: _ctx.localValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event)),
      ref: "chatInput",
      minHeight: _ctx.minHeight,
      maxHeight: _ctx.maxHeight,
      reset: _ctx.reset,
      placeholderText: _ctx.placeholderText,
      placeholderKey: _ctx.placeholderKey
    }, null, 8, ["modelValue", "minHeight", "maxHeight", "reset", "placeholderText", "placeholderKey"])
  ]))
})